import WysiwygPanel from "./WysiwygPanel";

export default WysiwygPanel;
